// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 106 ? "b9633c63" : chunkId) + "." + {"52":"4715af95f135e72b","106":"43f395d99202f17c"}[chunkId] + ".js";
};